import { axiosCore } from './http-core-service';
import { ContactUsDto } from './dtos/contact-us.dto';

/**
 * Service Contactez-nous
 * @return si valide
 */
export const contactUs = async (data: ContactUsDto): Promise<string> => {
    const response = await axiosCore.post('/message_contacts', data);
    return response.data;
};
